import { useTranslation } from "react-i18next";
import TodayMarker from "../../TodayMarker/TodayMarker";
import NLMSystemOverrides from "./NLMSystemOverrides";
import { useNLMThresholdSettings } from "../Hooks/useNLMThresholdSettings";
import { NLMModelRunDetails } from "./NLMModelRunDetails";
import NLMProjectOverridesGrid from "./NLMProjectOverridesGrid";

const NLMThresholdSettings = () => {
  const env = process.env.REACT_APP_ENV;
  const { t } = useTranslation();
  const { hasAccountOwnerRole, hasProjectAdministrator } =
    useNLMThresholdSettings();
  return (
    <div>
      <div
        className="nlm-threshold-settings__header"
        data-testid="nlm-threshold-settings__header"
      >
        {t("nlmsettings.nlm_model")}
      </div>
      <div className="nlm-threshold-settings__body">
        {env !== "prod" && <TodayMarker />}
        {hasAccountOwnerRole && <NLMSystemOverrides />}
        {hasAccountOwnerRole && <NLMModelRunDetails />}
        {hasProjectAdministrator && (
          <NLMProjectOverridesGrid />
        )}
      </div>
    </div>
  );
};

export default NLMThresholdSettings;
